import type { MessageKey } from "../../shared/i18n";
import {
  AccountTreeIcon,
  BarcodeIcon,
  DeleteSweepIcon,
  FileDownloadIcon,
  LayerGroupIcon,
  PhotoLibraryIcon,
  PrintIcon,
} from "../../shared/components/icons";
import type { Destination } from "./routes";

export type ShellIcon = typeof BarcodeIcon;

/** One top-level destination: the only entries the three shells share. */
export interface DestinationItem {
  destination: Destination;
  path: string;
  labelKey: MessageKey;
  icon: ShellIcon;
}

/**
 * Catalog, Browse, Items and Photos — the one set of destinations (catalog-
 * selector 02: the Catalogs page leads the nav on every shell).
 */
export const DESTINATIONS: readonly DestinationItem[] = [
  { destination: "catalogs", path: "/catalogs", labelKey: "catalog", icon: LayerGroupIcon },
  { destination: "browse", path: "/browse", labelKey: "browse", icon: AccountTreeIcon },
  { destination: "items", path: "/items", labelKey: "sidebarItems", icon: BarcodeIcon },
  { destination: "photos", path: "/gallery", labelKey: "gallery", icon: PhotoLibraryIcon },
];

/** A tail action: Print/Trash navigate, Export is a download link (spec §7). */
export interface TailItem {
  key: "print" | "export" | "trash";
  labelKey: MessageKey;
  icon: ShellIcon;
  path?: string;
  href?: string;
}

/** The tail in spec order: Print, Export, Trash. */
export const TAIL_ITEMS: readonly TailItem[] = [
  { key: "print", path: "/print", labelKey: "print", icon: PrintIcon },
  { key: "export", href: "/api/export/csv", labelKey: "export", icon: FileDownloadIcon },
  { key: "trash", path: "/trash", labelKey: "trash", icon: DeleteSweepIcon },
];

/** Add is the primary action in the tablet rail and the desktop sidebar. */
export const ADD_PATH = "/add";
